function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M8.574,47.781V36H6.787V47.781a2.681,2.681,0,1,0,1.787,0Zm-.894,3.41a.894.894,0,1,1,.894-.894A.894.894,0,0,1,7.681,51.19Z",
  transform: "translate(-1.426 -4.726)",
  fill: "#494949"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_40",
  "data-name": "Path 40",
  d: "M13.681,36a2.674,2.674,0,0,0-.894,5.2V52.977h1.787V41.2a2.674,2.674,0,0,0-.894-5.2Zm0,3.574a.894.894,0,1,1,.894-.894A.894.894,0,0,1,13.681,39.574Z",
  transform: "translate(-2.065 -4.726)",
  fill: "#494949"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_41",
  "data-name": "Path 41",
  d: "M52.574,47.781V36H50.787V47.781a2.681,2.681,0,1,0,1.787,0Zm-.894,3.41a.894.894,0,1,1,.894-.894A.894.894,0,0,1,51.681,51.19Z",
  transform: "translate(-6.11 -4.726)",
  fill: "#494949"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_42",
  "data-name": "Path 42",
  d: "M57.681,36a2.674,2.674,0,0,0-.894,5.2V52.977h1.787V41.2a2.674,2.674,0,0,0-.894-5.2Zm0,3.574a.894.894,0,1,1,.894-.894A.894.894,0,0,1,57.681,39.574Z",
  transform: "translate(-6.748 -4.726)",
  fill: "#494949"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M39.423,29.594a2.666,2.666,0,0,0-1,.2A2.657,2.657,0,0,0,34.061,28.5a2.6,2.6,0,0,0-2.681-.533V20.282a9.862,9.862,0,0,0,7.032-8.005l3.778,2.078a8.772,8.772,0,1,0,1.816-1.042L38.5,10.285a9.816,9.816,0,0,0-19.6,0l-5.505,3.027a9.036,9.036,0,1,0,1.815,1.041l3.779-2.078a9.856,9.856,0,0,0,7.033,8.007V36.753a2.68,2.68,0,0,1-.273,1.179L25,34.185a5.775,5.775,0,0,0-5.647-4.629,2.265,2.265,0,0,0-1.884,3.521l.919,1.38a3.986,3.986,0,0,1,.636,1.71l.618,4.944a6.07,6.07,0,0,0,.748,2.276l2.951,6.071v1.582H21.552V56.4H41.21V51.039H39.423v-1.49l1.43-1.906A6.289,6.289,0,0,0,42.1,43.89V32.274a2.684,2.684,0,0,0-2.681-2.681Zm8.042-.894a7.1,7.1,0,0,1-4.282-1.438,5.359,5.359,0,0,1,8.564,0A7.1,7.1,0,0,1,47.464,28.7Zm-2.681-8.042a2.681,2.681,0,1,1,2.681,2.681A2.684,2.684,0,0,1,44.784,20.658ZM47.464,14.4a7.14,7.14,0,0,1,5.569,11.62,7.145,7.145,0,0,0-2.619-2.035,4.468,4.468,0,1,0-5.9,0A7.155,7.155,0,0,0,41.9,26.023,7.14,7.14,0,0,1,47.464,14.4ZM9.935,28.7a7.1,7.1,0,0,1-4.282-1.438,5.359,5.359,0,0,1,8.564,0A7.1,7.1,0,0,1,9.935,28.7ZM7.255,20.658a2.681,2.681,0,1,1,2.681,2.681A2.684,2.684,0,0,1,7.255,20.658Zm9.829.894a7.107,7.107,0,0,1-1.58,4.471,7.145,7.145,0,0,0-2.619-2.035,4.468,4.468,0,1,0-5.9,0,7.155,7.155,0,0,0-2.619,2.035,7.146,7.146,0,1,1,12.717-4.471Zm3.574-10.723A8.042,8.042,0,1,1,35.1,15.683a7.116,7.116,0,0,0-3.435-3.321,4.468,4.468,0,1,0-5.922,0A7.116,7.116,0,0,0,22.3,15.684a8.021,8.021,0,0,1-1.645-4.855ZM31.381,9.042A2.681,2.681,0,1,1,28.7,6.361,2.684,2.684,0,0,1,31.381,9.042Zm-7.718,8.045a5.337,5.337,0,0,1,10.076,0,7.972,7.972,0,0,1-2.679,1.432,2.657,2.657,0,0,0-4.717,0A7.979,7.979,0,0,1,23.662,17.087Zm15.76,37.526H23.339V52.826H39.423Zm.894-10.723a4.493,4.493,0,0,1-.894,2.681l-1.787,2.383v2.085H25.126V49.046l-3.16-6.493a4.412,4.412,0,0,1-.554-1.661l-.618-4.945a5.772,5.772,0,0,0-.922-2.48l-.92-1.381a.478.478,0,0,1,.4-.743,3.984,3.984,0,0,1,3.895,3.193l1.149,5.743h2.178l.763-1.527a4.492,4.492,0,0,0,.472-2V19.764a.894.894,0,0,1,1.787,0v14.3h1.787V30.487a.894.894,0,0,1,1.787,0v3.574h1.787V30.487a.894.894,0,1,1,1.787,0v3.574h1.787V32.274a.894.894,0,1,1,1.787,0Z",
  transform: "translate(-1 -1)",
  fill: "#494949"
});

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "select",
    width: 55.4,
    height: 55.4,
    viewBox: "0 0 55.4 55.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.07aa0e61.svg";
export { ForwardRef as ReactComponent };